import "./style.css";

function CustomLoader() {
  return (
    // <div className="dot-loader">
    //   <div></div>
    //   <div></div>
    //   <div></div>
    // </div>
    <div
      className="w-100 h-100 d-flex justify-content-center align-items-center"
      // style={{ backgroundColor: "rgba(255, 255, 255, 0.8)", zIndex: 9999 }}
    >
      <img src="/loader.gif" width="150" alt="Loading..." />
    </div>
  );
}

export default CustomLoader;
